import { Text } from "@chakra-ui/react";
import TextField from "./TextField";
import PhoneField from "./PhoneField";
import EmailField from "./EmailField";
import SelectField from "./SelectField";
import CheckboxField from "./CheckboxField";
import TextAreaField from "./TextAreaField";
import NameField from "./NameField";
import FileUpload from "./FileUpload";
import RadioField from "./RadioField";

export default function GravityFormsField({ field }) {
  switch (field.type) {
    case "TEXT":
      return <TextField {...field} />;
    case "PHONE":
      return <PhoneField {...field} />;
    case "EMAIL":
      return <EmailField {...field} />;
    case "SELECT":
      return <SelectField {...field} />;
    case "CHECKBOX":
      return <CheckboxField {...field} />;
    case "RADIO":
      return <RadioField {...field} />;
    case "TEXTAREA":
      return <TextAreaField {...field} />;
    case "NAME":
      return <NameField {...field} />;
    case "FILEUPLOAD":
      return <FileUpload {...field} />;
    default:
      return <Text>{`Field type not supported: ${field.type}`}</Text>;
  }
}
